import { reducer } from '@core-ui/reducers_handlers';
import { handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';
import * as actions from './actions';
import { MODALS } from './consts';

export interface IModalsState {
  modalId: MODALS | null;
  data: string | null;
}

const defaultState = Immutable<IModalsState>({
  modalId: null,
  data: null,
});

export default handleActions<typeof defaultState>(
  {},
  reducer<typeof defaultState>(actions.reducerName, defaultState),
);
